import type { Router, RouteRecordRaw } from 'vue-router'
import { PageName } from 'shared/lib/types/app/pages'

export const moduleRoute: RouteRecordRaw = {
  path: 'ai-consultant',
  name: PageName.AI_CONSULTANT,
  component: () => import('modules/ai-consultant/pages/AiConsultantIndex.vue'),
  meta: {
    breadcrumbName: 'ИИ-Консультант',
    breadcrumbOnly: true,
  },
}

export default (router: Router) => {
  router.addRoute(PageName.MAIN_LAYOUT, moduleRoute)
}
